export const messages = {
  en: {
    editComplaintType: {
      title: 'Edit Complaint Type',
      typeName: 'Type Name',
      typeNamePlaceholder: 'Required, please enter type name',
      notifyWay: 'Notification Method',
      notifyWayPlaceholder: 'Required, please select notification method',
      sms: 'SMS',
      wechat: 'WeChat',
      workLicense: 'WeChat + Work License',
      appraiseReply: 'Evaluation Reply',
      appraiseReplyPlaceholder: 'Required, please select evaluation reply',
      autoReply: 'Auto Reply',
      manualReply: 'Manual Reply',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      selectStaff: 'Select Staff',
      saveSuccess: 'Save successfully',
      saveError: 'Save failed',
      loadError: 'Failed to load complaint type details'
    },
    orgTree: {
      loadError: 'Failed to load organization tree'
    }
  },
  zh: {
    editComplaintType: {
      title: '修改投诉类型',
      typeName: '类型名称',
      typeNamePlaceholder: '必填，请填写类型名称',
      notifyWay: '通知方式',
      notifyWayPlaceholder: '必填，请选择通知方式',
      sms: '短信',
      wechat: '微信',
      workLicense: '微信+员工工牌',
      appraiseReply: '评价回复',
      appraiseReplyPlaceholder: '必填，请选择评价回复',
      autoReply: '自动回复',
      manualReply: '人工回复',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      selectStaff: '选择员工',
      saveSuccess: '保存成功',
      saveError: '保存失败',
      loadError: '加载投诉类型详情失败'
    },
    orgTree: {
loadError: '加载组织树失败'
    }
  },
  'zh-TW': {
    editComplaintType: {
      title: '修改投訴類型',
      typeName: '類型名稱',
      typeNamePlaceholder: '必填，請填寫類型名稱',
      notifyWay: '通知方式',
      notifyWayPlaceholder: '必填，請選擇通知方式',
      sms: '短信',
      wechat: '微信',
      workLicense: '微信+員工工牌',
      appraiseReply: '評價回復',
      appraiseReplyPlaceholder: '必填，請選擇評價回復',
      autoReply: '自動回復',
      manualReply: '人工回復',
      remark: '備註',
      remarkPlaceholder: '選填，請填寫備註',
      selectStaff: '選擇員工',
      saveSuccess: '保存成功',
      saveError: '保存失敗',
      loadError: '加載投訴類型詳情失敗'
    },
    orgTree: {
      loadError: '加載組織樹失敗'
    }
  }
}